import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonService } from '../common.service';
import { resolve } from 'dns';
import { ResponsiveService } from '../responsive.service';

@Injectable({
  providedIn: 'root'
})
export class MicrositeGuard implements CanActivate, CanActivateChild {
  constructor(private commonService: CommonService, private route: Router, private responsiveService: ResponsiveService){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (!this.commonService.isHybrid()) {
        return this.route.navigate(['pagenotfound']);
      }
    return true;
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  
}
